import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar_menu";
import { useAuth } from "../auth/AuthContext";
import "../App.css";

export default function Profil() {
  const { user, nacitajProfil, ulozProfil, zmenHeslo } = useAuth();

  const [name, setName] = useState("");
  const [priezvisko, setPriezvisko] = useState("");
  const [telefon, setTelefon] = useState("");
  const [nbsCislo, setNbsCislo] = useState("");

  const [stareHeslo, setStareHeslo] = useState("");
  const [noveHeslo, setNoveHeslo] = useState("");
  const [noveHeslo2, setNoveHeslo2] = useState("");

  const [errProfil, setErrProfil] = useState("");
  const [okProfil, setOkProfil] = useState("");

  const [errHeslo, setErrHeslo] = useState("");
  const [okHeslo, setOkHeslo] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const u = await nacitajProfil();
        setName(u?.name || "");
        setPriezvisko(u?.priezvisko || "");
        setTelefon(u?.telefon || "");
        setNbsCislo(u?.nbsCislo || "");
      } catch {}
    })();
  }, [nacitajProfil]);

  useEffect(() => {
    if (!user) return;
    setName(user.name || "");
    setPriezvisko(user.priezvisko || "");
    setTelefon(user.telefon || "");
    setNbsCislo(user.nbsCislo || "");
  }, [user]);

  const submitProfil = async (e) => {
    e.preventDefault();
    setErrProfil("");
    setOkProfil("");

    try {
      await ulozProfil({ name, priezvisko, telefon, nbsCislo });
      setOkProfil("Profil bol úspešne uložený.");
    } catch (e2) {
      setErrProfil(e2.message || "Nepodarilo sa uložiť profil.");
    }
  };

  const submitHeslo = async (e) => {
    e.preventDefault();
    setErrHeslo("");
    setOkHeslo("");

    try {
      const res = await zmenHeslo({ stareHeslo, noveHeslo, noveHeslo2 });
      setOkHeslo(res?.message || "Heslo bolo zmenené.");
      setStareHeslo("");
      setNoveHeslo("");
      setNoveHeslo2("");
    } catch (e2) {
      setErrHeslo(e2.message || "Nepodarilo sa zmeniť heslo.");
    }
  };

  return (
    <>
      <Navbar />

      <div className="App">
        <div className="app-shell">
          <div className="board board--profil">
            <div className="col">
                <section className="card-section card--full profil-karta">
                <h2>Profil používateľa</h2>

                <form onSubmit={submitProfil} className="profil-form">
                    <div className="profil-row profil-row--readonly">
                    <div className="profil-label">Prihlasovacie meno (mail):</div>
                    <div className="form form--profil form--profil-readonly">
                        <input
                        className="form_input"
                        type="text"
                        value={user?.email || ""}
                        disabled
                        />
                    </div>
                    </div>

                    <div className="profil-row profil-row--readonly">
                    <div className="profil-label">Rola:</div>
                    <div className="form form--profil form--profil-readonly">
                        <input
                        className="form_input"
                        type="text"
                        value={user?.rolaNazov || ""}
                        disabled
                        />
                    </div>
                    </div>

                    <div className="profil-row">
                    <div className="profil-label">Meno:</div>
                    <div className="form form--profil">
                        <input
                        className="form_input"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        />
                    </div>
                    </div>

                    <div className="profil-row">
                    <div className="profil-label">Priezvisko:</div>
                    <div className="form form--profil">
                        <input
                        className="form_input"
                        type="text"
                        value={priezvisko}
                        onChange={(e) => setPriezvisko(e.target.value)}
                        />
                    </div>
                    </div>

                    <div className="profil-row">
                    <div className="profil-label">Mobil:</div>
                    <div className="form form--profil">
                        <input
                        className="form_input"
                        type="text"
                        value={telefon}
                        onChange={(e) => setTelefon(e.target.value)}
                        />
                    </div>
                    </div>

                    <div className="profil-row">
                    <div className="profil-label">NBS číslo:</div>
                    <div className="form form--profil">
                        <input
                        className="form_input"
                        type="text"
                        value={nbsCislo}
                        onChange={(e) => setNbsCislo(e.target.value)}
                        />
                    </div>
                    </div>

                    <div className="profil-footer">
                        <div className="profil-hlaska-wrap">
                            {errProfil && (
                            <div className="form_hint error profil-hlaska">
                                {errProfil}
                            </div>
                            )}

                            {okProfil && (
                            <div className="form_hint profil-hlaska">
                                {okProfil}
                            </div>
                            )}
                        </div>

                        <div className="profil-akcie">
                            <button
                            type="submit"
                            className="form_input action-btn profil-btn"
                            >
                            Uložiť zmeny
                            </button>
                        </div>
                        </div>
                </form>
                </section>
            </div>

            <div className="col">
                <section className="card-section card--full profil-karta">
                <h2>Zmena hesla</h2>

                <form onSubmit={submitHeslo} className="profil-form profil-form--heslo">
                    <div className="profil-row">
                    <div className="profil-label">Aktuálne heslo:</div>
                    <div className="form form--profil form--profil-heslo">
                        <input
                        className="form_input"
                        type="password"
                        value={stareHeslo}
                        onChange={(e) => setStareHeslo(e.target.value)}
                        />
                    </div>
                    </div>

                    <div className="profil-row">
                    <div className="profil-label">Zadaj nové heslo:</div>
                    <div className="form form--profil form--profil-heslo">
                        <input
                        className="form_input"
                        type="password"
                        value={noveHeslo}
                        onChange={(e) => setNoveHeslo(e.target.value)}
                        />
                    </div>
                    </div>

                    <div className="profil-row">
                    <div className="profil-label">Zopakuj nové heslo:</div>
                    <div className="form form--profil form--profil-heslo">
                        <input
                        className="form_input"
                        type="password"
                        value={noveHeslo2}
                        onChange={(e) => setNoveHeslo2(e.target.value)}
                        />
                    </div>
                    </div>

                    <div className="profil-footer">
                        <div className="profil-hlaska-wrap">
                            {errHeslo && (
                            <div className="form_hint error profil-hlaska">
                                {errHeslo}
                            </div>
                            )}

                            {okHeslo && (
                            <div className="form_hint profil-hlaska">
                                {okHeslo}
                            </div>
                            )}
                        </div>

                        <div className="profil-akcie">
                            <button
                            type="submit"
                            className="form_input action-btn profil-btn"
                            >
                            Zmeniť heslo
                            </button>
                        </div>
                        </div>
                </form>
                </section>
            </div>
            </div>
        </div>
      </div>
    </>
  );
}